<template>
    <div>
        <view-item v-if="!!item" :item="item" @success="alertSuccess" @delete-item="deleteType" @cancel="item = false"
            @error="showError"></view-item>

        <list-items v-else :items="items" :title="title" @show-item="showItem" ref="table">
            <b-button block variant="primary" v-if="hasPermissionCreate" @click="item = {}"><img v-b-tooltip.hover
                    :title="$addLabel()" src="@/assets/images/icon/blue-add.svg">
            </b-button>
        </list-items>
    </div>
</template>
<script>
import ListItems from './ListItems'
import ViewItem from './ViewItem'

import utilityMixins from '@/mixins/utilityMixins'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'ItemTypes',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, utilityMixins, permissionsMixins],
    data: () => {
        return {
            item: null,
            title: 'Item&nbsp;type',
        }
    },
    mounted() {
        this.$store.dispatch("masterItem/unit_of_measures");
        this.doSearch()
    },
    computed: {
        componentName() { return this.$translate('item_type') },
        items() {
            const items = this.$store.state.itemType.items
            console.log('items', items)
            return items.map(x => {
                x.is_task = !!x.is_task
                x.is_order_item = !!x.is_order_item
                //x.is_asset = !!x.is_asset
                x.is_discount = !!x.is_discount
                return x
            })
        },
    },

    methods: {
        async doSearch() {
            await this.$store.dispatch('itemType/fetchAll')
        },

        showItem(id) {
            const item = this.items.find(x => x.id === id)
            this.item = { ...item }
        },

        alertSuccess(action, message) {
            console.log(message, "sucesss")
            this.genericToast(
                this.componentName,
                this.$translate(action.toLowerCase()),
                'success',
                message
            )
            //this.doToast('Success', `Item ${action}!`, 'success')
            this.item = null
            this.doSearch()
        },

        showError(error) {
            // const interror = 'Internal Server Error'
            // if (interror == error.message) {
            this.genericToast(
                this.componentName,
                this.$translate('error'),
                'danger',
                `${error.message}`
            )
            // }
        },
    },
}
</script>
<style></style>
